/**
 * Styled Components - Created by david on 26/02/18.
 */
import Icon from 'antd/lib/icon'
import styled, { keyframes } from 'styled-components'
import { GREEN_BRIGHT, RED, GRAY_LIGHTEST, BLACK_BG, WHITE, BLACK } from '../../theme/colors'

interface ItemProps {
  wide?: boolean
  secondary?: boolean
}

interface StyledProps {
  showLeftTabs?: boolean
}

export const fadeIn = keyframes`
  to {
    opacity: 1;
  }
`

export const Container = styled.div`
  display: flex;
  height: calc(100vh - 81px);
  background-color: #fff;
  &.column {
    flex-direction: column;
    height: calc(100dvh - 43px);
  }
`

export const Text = styled.div`
  color: #fff;
`

export const StyledTitle = styled.div`
  background-color: #fff;
  padding: 16px 0;
  box-sizing: border-box;
  color: black;
  min-height: 64px;
  font-size: 24px;
  text-align: left;
  flex: 1;
  margin-left: 15px;
`

export const LoadingContainer = styled.div`
  display: flex;
  flex: 1;
  height: 100vh;
  align-items: center;
  justify-content: center;
`

export const MobileToolBar = styled.div`
  display: flex;
  background-color: ${BLACK_BG};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.07);
  height: 50px;
  position: absolute;
  width: 100%;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const MobileTitle = styled.h2`
  margin: 0 0 0 30px;
  color: white;
  font-family: 'Avenir Next';
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.2px;
`
export const ActionMobileItems = styled.div`
  height: 100%;
  display: flex;
`

export const MobileItem = styled.div`
  width: ${({ wide }: ItemProps) => wide ? '80px' : '50px'};
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
`

export const ButtonPro = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  gap: 6px;
  border: 1px solid ${GREEN_BRIGHT};
  margin: 6px;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: #3d3d3d;
`

export const ButtonSave = styled.div`
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #2271a7;
  margin: 6px;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: #1c415e;
`

export const ButtonImg = styled.img`
  padding-left: 2px;
`

export const ButtonText = styled.p`
  font-size:  ${({ secondary }: ItemProps) => secondary ? '12px' : '14px'};
  margin: 0;
  color: ${({ secondary }: ItemProps) => secondary ? GREEN_BRIGHT : WHITE};
`

export const BackCircle = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 16px;
  border-color: #5f6062;
  border-width: 1px;
  border-style: solid;
  border-radius: 50%;
  z-index: 1;
  top: 86px;
  opacity: 0;
  animation: ${fadeIn} 0.5s cubic-bezier(0.67, 0.35, 0.565, 1) both;
  &.customizeTab {
    top: 25%;
  }
`

export const BackIcon = styled.img`
  width: 12px;
  height: 12px;
`

export const RightColumn = styled.div`
  /* width: ${({ showLeftTabs }: StyledProps) => showLeftTabs ? '100%' : 'calc(100% - 470px)'}; */
  width: 100%;
`

export const FloatingControl = styled.div<{ $expanded: boolean}>`
  display: none;
  @media (max-width: 698px) {
    display: flex;
    align-items: center;
    width: ${props => props.$expanded ? '60px' : '28px'};
    position: absolute;
    height: fit-content;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto 0;
    z-index: 10;
    background-color: ${BLACK};
    align-items: center;
    padding: 12px 0px;
    transition: all .25s;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
`

export const OpenButton = styled.div`
  position: absolute;
  width: 0; 
  height: 0;
  left: -10px;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent; 
  border-right: 10px solid black; 
`

export const CloseIcon = styled(Icon)`
  color: #ffcece;
  font-size: 22px;
  margin-bottom: 6px;
`

export const FloatingControlLabel = styled.div`
  color: white;
  font-size: 14px;
  text-transform: uppercase;
  transform: rotate(180deg);
  letter-spacing: 1.5px;
  white-space: nowrap;
  writing-mode: vertical-rl;
  margin-left: 6px;
  margin-inline: 12px;
`

export const CloseButton = styled.div``

export const ThreeDButton = styled.img<{ $selected: boolean}>`
  max-width: 46px;
  border-radius: 3px;
  padding: 6px;
  border: solid 1px #cfcfcf;
  user-select: none !important;
`

export const ShuffleButton = styled.img`
  max-width: 46px;
  border-radius: 3px;
  padding: 10px;
  border: solid 1px #cfcfcf;
  transition: all .5s;
  -webkit-touch-callout: none !important;
  user-select: none !important;
`
export const ButtonWithIcon = styled.div`
  max-width: 46px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border: solid 1px #cfcfcf;
  row-gap: 6px;
  border-radius: 3px;
`
export const FloatingButtonImg = styled.img`
  max-width: 30px;
  object-fit: contain;
  min-height: 28px;
  margin: 4px;
`
export const FloatingButtonText = styled.p`
  font-size: 8px;
  margin: 0;
  color: ${WHITE}
`

export const InfoMessage = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: -28px;
  background: #272727;
  vertical-align: middle;
`

export const FingerIcon = styled.img`
  max-width: 24px;
  vertical-align: middle;
  z-index: 2;
  background: #272727;
  margin-right: 8px;
`

export const CombosList = styled.div`
  width: 100%;
  overflow-x: scroll;
  max-height: 0;
  transition: max-height 0.3s ease;
  &.open {
    max-height: 32vh;
  }
`

export const VariantButton = styled.img<{ $selected: boolean}>`
  width: 50px;
  object-fit: contain;
  max-height: 50px;
  border: 1px solid ${props => props.$selected ? RED : '#cfcfcf'};
  border-radius: 3px;
  transition: all 0.25s;
  padding: 5px;
  margin-bottom: 8px;
  cursor: pointer;
  &:hover {
    background: ${GRAY_LIGHTEST};
  }
  @media (max-width: 698px) {
    width: 44px;
    height: 44px;
    padding: 2px;
    margin-bottom: 0px;
    background: white;
    filter: invert(100%);
  }
`

export const ActionDiv = styled.div`
  display: flex;
  flex-flow: column;
  margin-left: 8px;
  row-gap: 12px;
  animation: fade-in-right-nav 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right-nav {
    0% {
      transform: translateX(-8px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/styledComponents.tsx